import React, { Component } from 'react';
import './textInput.scss';

/** @import { TextInputProps, TextInputState } from './TextInputTypes' */

/**
 * @template {TextInputProps} [TProps=TextInputProps]
 * @extends {Component<TProps>} 
 **/
class TextInput extends Component {
  static defaultProps = {
    onBlur: () => {},
    label: ''
  };

  /** @type {TextInputState} */
  state = { value: '' };

  constructor(/** @type {TProps} */ props) {
    super(props);

    this.state = {
      value: props.value || ''
    };
  }

  static getDerivedStateFromProps(/** @type {TextInputProps} */ props) {
    if (!props.hasOwnProperty('value')) return null;
    return {
      value: props.value || ''
    };
  }

  componentDidMount() {
    this.props.focus && this.props.inputRef?.current && this.props.inputRef.current.focus();
  }

  getClassNames() {
    return [
      'text-input',
      this.state.value !== '' ? 'has-value' : '',
      this.props.disabled ? 'read-only' : '',
      this.props.className || ''
    ].join(' ').trim();
  }

  handleChange = (/** @type {React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>} */ e, triggerChange = true) => {
    if (this.props.disabled) return;

    const value = e.target.value;
    this.setState({ value: value });
    triggerChange && this.props.onChange && this.props.onChange(value);
  }

  renderLabel() {
    return this.props.label ? <label className='text-input__label'>{this.props.label}</label> : null;
  }

  render() {
    return (
      <div className='text-input__wrapper'>
        {this.renderLabel()}
        <input
          ref={this.props.inputRef}
          name={this.props.name}
          className={this.getClassNames()}
          placeholder={this.props.placeholder}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          value={this.state.value}
          type={this.props.type || "text"}
          onBlur={this.props.onBlur}
        />
      </div>
    );
  }
}

export default TextInput;
